import { checkControl, checkLabel } from "./checkbox";

export const Radio = {
  baseStyle: {
    control: {
      ...checkControl,
      borderRadius: "full",
      _checked: { ...checkControl._checked, _before: { bg: "navy.900" } },
    },
    label: checkLabel,
  },
  defaultProps: { colorScheme: "leaf" },
};
